import { useEffect, useState } from "react";
import LiquidCanvas from "./components/LiquidCanvas";
import HeroContent from "./components/HeroContent";

export default function Home() {
  const [scrolled, setScrolled] = useState(false);
  const [time, setTime] = useState<string>("");

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const update = () => {
      const d = new Date();
      setTime(
        d.toLocaleTimeString("en-US", {
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        })
      );
    };
    update();
    const t = setInterval(update, 1000 * 30);
    return () => clearInterval(t);
  }, []);

  return (
    <div className="relative min-h-screen bg-background-50 text-foreground-950 overflow-x-hidden">
      {/* Top Nav */}
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled
            ? "bg-background-50/80 backdrop-blur-md border-b border-background-200/70"
            : "bg-transparent"
        }`}
      >
        <nav className="flex items-center justify-between px-6 md:px-10 h-16">
          <a
            href="/"
            className={`text-xl font-semibold tracking-tight transition-colors ${
              scrolled ? "text-foreground-950" : ""
            }`}
            style={{
              fontFamily: "Pacifico, cursive",
              color: scrolled ? undefined : "#fff3dc",
              textShadow: scrolled
                ? undefined
                : "0 1px 2px rgba(42, 22, 10, 0.55), 0 2px 14px rgba(42, 22, 10, 0.35)",
            }}
          >
            fluida
          </a>

          <ul
            className={`hidden md:flex items-center gap-8 text-sm transition-colors ${
              scrolled ? "text-foreground-700" : ""
            }`}
            style={{
              color: scrolled ? undefined : "rgba(255, 243, 220, 0.92)",
              textShadow: scrolled
                ? undefined
                : "0 1px 2px rgba(42, 22, 10, 0.55)",
            }}
          >
            <li>
              <a href="#work" className="hover:opacity-70 cursor-pointer whitespace-nowrap">
                Work
              </a>
            </li>
            <li>
              <a href="#studio" className="hover:opacity-70 cursor-pointer whitespace-nowrap">
                Studio
              </a>
            </li>
            <li>
              <a href="#process" className="hover:opacity-70 cursor-pointer whitespace-nowrap">
                Process
              </a>
            </li>
            <li>
              <a href="#contact" className="hover:opacity-70 cursor-pointer whitespace-nowrap">
                Contact
              </a>
            </li>
          </ul>

          <a
            href="#contact"
            className={`hidden md:inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer transition-all ${
              scrolled
                ? "bg-primary-500 text-background-50 hover:bg-primary-600"
                : "hover:opacity-90"
            }`}
            style={{
              background: scrolled ? undefined : "#fff3dc",
              color: scrolled ? undefined : "#2a160a",
            }}
          >
            Start a project
            <i className="ri-arrow-right-up-line" />
          </a>

          <button
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-full cursor-pointer ${
              scrolled ? "text-foreground-950" : ""
            }`}
            style={{
              color: scrolled ? undefined : "#fff3dc",
              textShadow: scrolled
                ? undefined
                : "0 1px 2px rgba(42, 22, 10, 0.55)",
            }}
            aria-label="Menu"
          >
            <i className="ri-menu-line text-xl" />
          </button>
        </nav>
      </header>

      {/* Hero with liquid canvas */}
      <section className="relative h-screen min-h-[640px] w-full overflow-hidden">
        <LiquidCanvas />
        <HeroContent time={time} />
      </section>
    </div>
  );
}